<template>
  <div>
    <ul class="selector block apply-multiple-days">
      <li v-for="(day, index) in weekdays" :key="index" :title="day.full_day">
        <input
          type="checkbox"
          :id="'multiple-' + day.index"
          name="apply-multiple-days"
          :value="day.index"
          v-model="selected_days"
          @change="$emit('change-prop-selected-days', selected_days)"
        />
        <label :for="'multiple-' + day.index">{{ day.mini_day }}</label>
      </li>
    </ul>
  </div>
</template>

<script>
import { weekdays_list } from "@/utils/common_func.js";

export default {
  model: {
    prop: "prop_selected_days",
    event: "change-prop-selected-days"
  },
  props: {
    prop_selected_days: {
      type: Array
    }
  },
  data() {
    return {
      weekdays: weekdays_list,
      selected_days: []
    };
  },
  watch: {
    prop_selected_days(new_value) {
      this.selected_days = new_value;
    }
  },
  mounted() {
    this.selected_days = this.prop_selected_days;
  }
};
</script>
<style scoped>
ul.selector.apply-multiple-days {
  display: flex;
}
</style>
